import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import GlobalHeader from "./GlobalHeader";
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var getClassName, leftItemsNode, rightItemsNode, leftItems, rightItems, rehydratedProps;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getClassName = getClassNameFactory("GlobalHeader");
            leftItemsNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "leftItems"
            })));
            rightItemsNode = domNode.querySelector(".".concat(getClassName({
              descendantName: "rightItems"
            })));

            if (!leftItemsNode) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return rehydrateChildren(leftItemsNode);

          case 6:
            _context.t0 = _context.sent;
            _context.next = 10;
            break;

          case 9:
            _context.t0 = null;

          case 10:
            leftItems = _context.t0;

            if (!rightItemsNode) {
              _context.next = 17;
              break;
            }

            _context.next = 14;
            return rehydrateChildren(rightItemsNode);

          case 14:
            _context.t1 = _context.sent;
            _context.next = 18;
            break;

          case 17:
            _context.t1 = null;

          case 18:
            rightItems = _context.t1;
            rehydratedProps = {
              leftItems: leftItems,
              rightItems: rightItems
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(GlobalHeader, rehydratedProps));

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();